export default __webpack_public_path__ + "static/media/dashboard.7eab0dd7.svg";